import React from 'react'

const Footer = () => {
 
  return (
    <footer className='bg-dark text-light py-3'>
      <p className="text-center">
        Copyright &copy; ToDOList.com
      </p>
    </footer>
  )
}

export default Footer
